import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Rsee from '../../assets/images/Rsee.webp';
import Star1 from '../../assets/images/Star1.webp';
import Image from '../../component/Image';
import Loader from '../../component/Spin';
import useSetState from '../../hooks/useSetState';
import { loginOrRegister } from '../../redux/login/actions';
import './style.css';

const Login = () => {
  let history = useHistory();

  const { loginOrRegisterLoading } = useSelector((state) => ({
    loginOrRegisterLoading: state.loginOrRegisterReducer.loginOrRegisterLoading,
  }));

  const [showKeyboard, setShowKeyboard] = useState(false);

  const [controls, setControls] = useSetState({
    mobileNumber: '',
  });

  const onChangeValue = (controleName, value) => {
    setControls({ [controleName]: value });
  };

  const dispatch = useDispatch();

  const onTouchInput = () => {
    if (!showKeyboard) {
      setShowKeyboard(true);
    }
  };

  const submitForm = (event) => {
    event.preventDefault();
    let data = { mobileNumber: controls.mobileNumber };

    dispatch(loginOrRegister(data))
      .then((res) => {
        if (res.payload.action === 'REGISTER') {
          // user not exist
          history.push({
            pathname: '/login/register',
            mobileNumber: controls.mobileNumber,
          });
        } else if (res.payload.action === 'VERIFY_PHONE_NUMBER') {
          // user is pending
          history.push({
            pathname: '/login/verification-code',
            mobileNumber: controls.mobileNumber,
            action: 'VERIFY_PHONE_NUMBER',
          });
        } else if (res.payload.action === 'LOGIN_BY_PASSWORD') {
          // user is active & has password
          history.push({
            pathname: '/login/enter-password',
            mobileNumber: controls.mobileNumber,
          });
        } else if (res.payload.action === 'LOGIN_BY_SMS_VERIFICATION') {
          // user is active but doesn't set password
          history.push({
            pathname: '/login/verification-code',
            mobileNumber: controls.mobileNumber,
            action: 'LOGIN_BY_SMS_VERIFICATION',
          });
        }
      })
      .catch((error) => {
        console.log('error', error);
        if (error.payload.action === 'VERIFY_PHONE_NUMBER') {
          // user is pending
          history.push({
            pathname: '/login/verification-code',
            mobileNumber: controls.mobileNumber,
            action: 'VERIFY_PHONE_NUMBER',
          });
        }
      });
  };

  return (
    <Loader spinning={loginOrRegisterLoading}>
      <section className='overflow-x-hidden scrollbar-hide md:w-1/2 lg:w-1/3 m-auto relative h-screen'>
        <div className='flex justify-center items-end h-1/3'>
          <div className='grid grid-cols-1 z-1'>
            <Image
              src={Star1}
              wrapperClassName='place-self-end animate-pulse my-3'
            />
            <Image src={Rsee} wrapperClassName='place-self-center' />
            <label className='text-center text-md mt-5 text-black'>
              {locales('title.easy.reserve')}
            </label>
          </div>
        </div>

        <div className='h-2/3'>
          <form
            onSubmit={(event) => submitForm(event)}
            id='loginOrRegister'
            className={`my-2 relative`}
          >
            <section className='grid grid-cols-1 w-full'>
              <h1 className='text-2xl pt-14 pb-3 px-[10%]'>
                {locales('login.and.register')}
              </h1>
              <label className='text-sm text-right py-3 px-[10%]'>
                {locales('please.enter.your.number')}
              </label>
              <input
                type='tel'
                value={controls.mobileNumber}
                placeholder='شماره موبایل'
                className='place-self-center large-button rounded-lg text-md focus:outline-none border border-lightBorder'
                maxLength={11}
                onClick={onTouchInput}
                onChange={(event) =>
                  onChangeValue('mobileNumber', event.target.value)
                }
              />
            </section>
          </form>
          <div className='w-full flex justify-center absolute bottom-4 right-0'>
            <button
              type='submit'
              form='loginOrRegister'
              className='large-button bg-primary-100 text-white text-md'
            >
              {locales('login')}
            </button>
          </div>
        </div>
      </section>
    </Loader>
  );
};

export default Login;
